// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/tab-pane.css
// module id = DSCY
// module chunks = 4